import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeDeleteDocument } from "../../domain/use-cases/delete-document"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const deleteDocument = makeDeleteDocument(httpDocumentRepository)

export const useDeleteDocument = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteDocument(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["documents"] }),
  })
}
